import React from 'react';
import { Route } from 'react-router-dom';
import AnimatedPage from '../components/AnimatedPage';

// Pages
import HomePage from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import TrainerProfilePage from '../pages/TrainerProfilePage';
import VerifyEmailPage from '../pages/VerifyEmailPage';
import SearchPage from '../pages/SearchPage';
import CommunityPage from '../pages/CommunityPage';

// Shop Pages
import ShopHomePage from '../pages/shop/ShopHomePage';
import ProductPage from '../pages/shop/ProductPage';
import CollectionPage from '../pages/shop/CollectionPage';
import CartPage from '../pages/shop/CartPage';
import CheckoutPage from '../pages/shop/CheckoutPage';
import OrderTrackingPage from '../pages/shop/OrderTrackingPage';
import GroupClassPage from '../pages/GroupClassPage';

// Blog Pages
import BlogHomePage from '../pages/blog/BlogHomePage';
import BlogPostPage from '../pages/blog/BlogPostPage';

// Newsletter Pages
import NewsletterVerify from '../pages/NewsletterVerify';
import NewsletterUnsubscribe from '../pages/NewsletterUnsubscribe';

// Static Pages
import CalorieCalculatorPage from '../pages/CalorieCalculatorPage';
import ContactPage from '../pages/ContactPage';
import StaticPage from '../pages/StaticPage';
import AboutPage from '../pages/AboutPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import TermsConditionsPage from '../pages/TermsConditionsPage';
import DisclaimerPage from '../pages/DisclaimerPage';
import DenemePage from '../pages/DenemePage';
import FAQPage from '../pages/FAQPage';
import BadgesPage from '../pages/BadgesPage';
import AdminResetPasswordPage from '../pages/AdminResetPasswordPage';

export const publicRoutes = (
  <>
    {/* Public Routes */}
    <Route path="/" element={<AnimatedPage><HomePage /></AnimatedPage>} />
    <Route path="/search" element={<AnimatedPage><SearchPage /></AnimatedPage>} />
    <Route path="/login" element={<AnimatedPage><LoginPage /></AnimatedPage>} />
    <Route path="/register" element={<AnimatedPage><RegisterPage /></AnimatedPage>} />
    <Route path="/forgot-password" element={<AnimatedPage><ForgotPasswordPage /></AnimatedPage>} />
    <Route path="/reset-password" element={<AnimatedPage><ResetPasswordPage /></AnimatedPage>} />
    <Route path="/verify-email" element={<AnimatedPage><VerifyEmailPage /></AnimatedPage>} />
    <Route path="/trainer/:id" element={<AnimatedPage><TrainerProfilePage /></AnimatedPage>} />

    {/* Shop Routes - Public */}
    <Route path="/shop" element={<AnimatedPage><ShopHomePage /></AnimatedPage>} />
    <Route path="/shop/products/:slug" element={<AnimatedPage><React.Suspense fallback={<div />}><ProductPage /></React.Suspense></AnimatedPage>} />
    <Route path="/shop/collections/:slug" element={<AnimatedPage><React.Suspense fallback={<div />}><CollectionPage /></React.Suspense></AnimatedPage>} />
    <Route path="/shop/cart" element={<AnimatedPage><CartPage /></AnimatedPage>} />
    <Route path="/cart" element={<AnimatedPage><CartPage /></AnimatedPage>} />
    <Route path="/checkout" element={<AnimatedPage><CheckoutPage /></AnimatedPage>} />

    {/* Public Order Tracking - No login required */}
    <Route path="/order-tracking" element={<AnimatedPage><OrderTrackingPage /></AnimatedPage>} />

    {/* Public Group Class Page - No login required */}
    <Route path="/group-class/:slug" element={<AnimatedPage><GroupClassPage /></AnimatedPage>} />

    {/* Blog Routes - Public */}
    <Route path="/blog" element={<BlogHomePage />} />
    <Route path="/blog/category/:categorySlug" element={<BlogHomePage />} />
    <Route path="/blog/post/:slug" element={<BlogPostPage />} />

    {/* Calorie Calculator - Public */}
    <Route path="/calorie-calculator" element={<AnimatedPage><CalorieCalculatorPage /></AnimatedPage>} />

    {/* Admin Password Reset (public route) */}
    <Route path="/admin/reset-password" element={<AdminResetPasswordPage />} />

    {/* Static Pages */}
    <Route path="/contact" element={<ContactPage />} />
    <Route path="/about" element={<AnimatedPage><AboutPage /></AnimatedPage>} />
    <Route path="/how-it-works" element={<StaticPage title="How It Works" content={<p>Learn how MyPersonalTrainers.ca works...</p>} />} />
    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
    <Route path="/terms-conditions" element={<TermsConditionsPage />} />
    <Route path="/disclaimer" element={<DisclaimerPage />} />
    <Route path="/deneme" element={<DenemePage />} />
    <Route path="/faq" element={<AnimatedPage><FAQPage /></AnimatedPage>} />
    <Route path="/badges" element={<AnimatedPage><BadgesPage /></AnimatedPage>} />
    <Route path="/social" element={<StaticPage title="Let's Get Social" content={<p>Connect with us on social media...</p>} />} />
    <Route path="/community" element={<AnimatedPage><CommunityPage /></AnimatedPage>} />
    <Route path="/collaboration" element={<AnimatedPage><StaticPage title="Collaboration" content={<p>Collaborate with us...</p>} /></AnimatedPage>} />

    {/* Newsletter Routes */}
    <Route path="/newsletter/verify" element={<NewsletterVerify />} />
    <Route path="/newsletter/unsubscribe" element={<NewsletterUnsubscribe />} />
  </>
);

export default publicRoutes;
